import { observer } from 'mobx-react';
import * as React from 'react';
import { emptyFragment } from '../../../../../../../../EmptyFragment';
import LearningCollectionEditStore from '../../../../../Edit/Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import { ExperienceResource } from '../../../ExperienceCatalog/Types';
import DateContainer from './DateContainer';

interface Props {
  context: ModifiableExperiencesContext;
  experienceResource: ExperienceResource;
  store: LearningCollectionEditStore;
}

const ScheduledDates: React.FC<Props> = ({ context, experienceResource, store }) =>
  store
    .selectedExperience(context, experienceResource)
    .map((experienceStore) => (
      <DateContainer
        experienceResource={experienceResource}
        experienceStore={experienceStore}
        store={store}
      />
    ))
    .getOrElse(emptyFragment);

export default observer(ScheduledDates);
